export default __webpack_public_path__ + "static/media/DLind_cropped.cc10bced.jpg";